<template>
  <div>
    <search-bar
      @search="onSearch"
      name="pr_code,pr_detail,pr_orispeccode"
      placeholder="输入产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div class="weui-cell" v-for="item in items" :key="item.mm_id">
        <div class="weui-cell__bd">
          <p>{{item.ma_Code}} #{{item.mm_detno}}</p>
          <p class="list-item-muted">{{item.mm_prodcode}} {{item.pr_detail}}</p>
          <p class="list-item-muted" v-if="item.pr_orispeccode">{{item.pr_orispeccode}}</p>
          <p class="list-item-muted" v-if="item.pr_spec">{{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>
            <span v-format="'#,##0.#'">{{item.mm_qty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <p class="list-item-muted" v-if="item.mm_havegetqty">
            已领:&nbsp;
            <span v-format="'#,##0.#'">{{item.mm_havegetqty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <p v-if="item.mm_returnmqty" class="list-item-muted">
            不良:&nbsp;
            <span v-format="'#,##0.#'" class="text-error">{{item.mm_returnmqty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <p v-if="item.mm_crapqty" class="list-item-muted">
            报废:&nbsp;
            <span v-format="'#,##0.#'" class="text-error">{{item.mm_crapqty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <p class="list-item-muted">
            损耗:&nbsp;
            <span class="text-error" v-format="'#,##0.##'">{{item.mm_losstotal || 0}}</span>
          </p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/report/productionLoss",
      filters: [
        {
          type: "date",
          name: "make.createTime"
        }
      ]
    };
  },
  mounted() {
    this.doSearch()
  }
};
</script>